export default "__VITE_ASSET__tF18eO9a__"